import { ReactComponent as Home } from '../assets/icons/Home.svg';
import { ReactComponent as HomeSelected } from '../assets/icons/HomeSelected.svg';
import { ReactComponent as HomeSelectedDarkMode } from '../assets/icons/HomeSelectedDarkMode.svg';
import { ReactComponent as Transaction } from '../assets/icons/Transaction.svg';
import { ReactComponent as TransactionSelected } from '../assets/icons/TransactionSelected.svg';
import { ReactComponent as TransactionSelectedDarkMode } from '../assets/icons/TransactionSelectedDarkMode.svg';
import { ReactComponent as InvoiceReconciliation } from '../assets/icons/invoice.svg';
import { ReactComponent as InvoiceReconciliationSelected } from '../assets/icons/InvoiceSelected.svg';
import { ReactComponent as InvoiceReconciliationSelectedDarkMode } from '../assets/icons/InvoiceSelectedDarkMode.svg';
import { ReactComponent as InvoiceReconciliationDarkMode } from '../assets/icons/InvoiceDarkMode.svg';
import { ReactComponent as Email } from '../assets/icons/Dashboard.svg';
import { ReactComponent as EmailSelected } from '../assets/icons/DashboardSelected.svg';
import { ReactComponent as EmailSelectedDarkMode } from '../assets/icons/DashboardSelectedDarkMode.svg';
import { ReactComponent as Logout } from '../assets/icons/Logout.svg';
import { ReactComponent as MyProfileSelected } from '../assets/icons/UserProfileSelected.svg';
import { ReactComponent as DarkModeSelected } from '../assets/icons/DarkModeSelected.svg';
import { ReactComponent as DarkMode } from '../assets/icons/DarkMode.svg';
import { ReactComponent as UserProfile } from '../assets/icons/UserProfile.svg';

export const SIDE_MENU_OPTIONS = [
    {
        name: 'Purchases',
        icon: Home,
        selectedIcon: HomeSelected,
        darkMode: HomeSelectedDarkMode,
        path: '/purchases/for-review',
        displayName: 'Purchases',
        collapse: true,
        locked: true,
        items: [
            {
                name: 'For Review',
                path: '/purchases/for-review',
            },
            {
                name: 'Matched',
                path: '/purchases/matched',
            },
            {
                name: 'Excluded',
                path: '/purchases/excluded',
            },
            {
                name: 'File Upload',
                path: '/purchases/file-upload',
            },
            {
                name: 'AI Matching',
                path: '/purchases/ai-matching',
            },
            {
                name: 'Purchase Activity',
                path: '/purchases/purchase-activity',
            },
            {
                name: 'Exclusion Rules',
                path: '/purchases/exclusion-rules',
            },
            {
                name: 'Payment Plan',
                path: '/purchases/payment-plan',
            },
        ],
    },
    {
        name: 'Transaction',
        icon: Transaction,
        selectedIcon: TransactionSelected,
        darkMode: TransactionSelectedDarkMode,
        path: '/transactions/import-bank-transactions',
        displayName: 'Import bank transactions',
        collapse: true,
        locked: true,
        items: [
            {
                name: 'Import bank transactions',
                path: '/transactions/import-bank-transactions',
            },

            {
                name: 'Upload Transactions',
                path: '/transactions/upload-transactions',
            },
        ],
    },
    {
        name: 'Emails',
        icon: Email,
        selectedIcon: EmailSelected,
        darkMode: EmailSelectedDarkMode,
        path: '/inventory-emails/emails',
        displayName: 'Import Emails',
        collapse: true,
        locked: true,
        items: [
            {
                name: 'Emails',
                path: '/inventory-emails/emails',
            },
            {
                name: 'Inventory',
                path: '/inventory-emails/inventory',
            },
        ],
    },
    {
        name: 'Invoices',
        icon: InvoiceReconciliation,
        selectedIcon: InvoiceReconciliationSelected,
        darkMode: InvoiceReconciliationSelectedDarkMode,
        path: '/invoices/payments',
        displayName: 'Invoices',
        collapse: true,
        locked: true,
        items: [
            {
                name: 'Payments',
                path: '/invoices/payments',
            },
            {
                name: 'Watchlist',
                path: '/invoices/watchlist',
            },
            {
                name: 'Credentials',
                path: '/invoices/credentials',
            },
            {
                name: 'Payments Upload',
                path: '/invoices/payments-upload',
            },
            {
                name: 'Invoices Upload',
                path: '/invoices/invoices-upload',
            },
        ],
    },
];

export const MOBILE_MENU_OPTIONS = [
    {
        name: 'Profile',
        icon: UserProfile,
        selectedIcon: MyProfileSelected,
        darkMode: UserProfile,
        path: '/profile',
        displayName: 'Profile',
    },
    {
        name: 'DarkMode',
        icon: DarkMode,
        darkMode: DarkMode,
        selectedIcon: DarkModeSelected,
        path: '/darkMode',
        showSwitch: true,
    },
    {
        name: 'Logout',
        icon: Logout,
        darkMode: Logout,
        selectedIcon: Logout,
        path: '/logout',
    },
    {
        name: 'Privacy Policy',
        path: 'https://www.termsfeed.com/live/c453ce2a-a7f6-4fd4-8956-efc53c6f2510',
    },
    {
        name: 'Terms and Conditions',
        path: 'https://www.termsfeed.com/live/2c8418f9-830b-4917-95c9-1a30f68a8c7a',
    },
    {
        name: 'Help Center',
        path: 'https://circlerhelp.blogspot.com/',
    },
    {
        name: 'Invite',
        path: '/invite',
        isCustomAction: true,
    },
    {
        name: 'About Us',
        path: 'https://circler.io/',
    },
];
